import React from 'react';

export const Info = () => {
  return (
    <div className='mx-4 mt-3 pb-1'>
      <p className='fs-4 mb-4'>
        Die Stadt Tengen war die erste Überschuss-Gemeinde im Landkreis
        Konstanz.
        <br />
        Auf Ihrer Gemarkung gibt es zahlreiche Anlagen zur regenerativen
        Stromerzeugung:
      </p>
      <p className='fs-4 mb-4'>
        - Der <strong>Windpark Verenafohren</strong> hat eine installierte
        Leistung von 9,9 MW und erzeugt jährlich rund 20 Mio kWh.
        <br />
        Für die Darstellung werden die Erzeugungsdaten des Vorjahrs verwendet.
      </p>
      <p className='fs-4 mb-4'>
        - Der <strong>Solarpark Berghof</strong> hat eine installierte Leistung
        von rd. 3,7 MW und erzeugt jährlich rund 4 Mio kWh.
        <br />
        Darüber hinaus gibt es zahlreiche PV-Dachanlagen auf Wohn- und
        Gewerbegebäuden.
        <br />
        Für die Darstellung werden die Erzeugungsdaten des Solarparks in
        Echtzeit verwendet und die Erzeugung der PV-Dachanlagen interpoliert.
      </p>
      <p className='fs-4 mb-4'>
        - Die beiden <strong>Biogasanlagen</strong> werden zusammen gefasst
        dargestellt.
        <br />
        Für die Darstellung werden die Erzeugungsdaten des Vorjahrs als
        Mittelwert verwendet.
      </p>
      <p className='fs-4 mb-4'>
        - Beim Strombedarf werden die Verbrauchsdaten des Netzbetreibers vom
        Vorjahr verwendet.
        <br />
        Alle Werte werden viertelstündlich aktualisiert.
      </p>
      <p className='fs-4 mb-4'>
        Insgesamt wird so dem Datenschutz Rechnung getragen und mit einem
        relativ geringen Aufwand dennoch ein repräsentativer Eindruck zur
        Strombilanz der Stadt Tengen geschaffen.
      </p>
    </div>
  );
};
